import { MethodType, ParamsFetchType, GenerateUrlApiType, ResponseType } from 'src_common/browser/apiUtils';
import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';
import * as t from 'io-ts';
import { isRight } from 'fp-ts/lib/Either';


const Response200IO = t.record(t.string, t.interface({
    id: t.string,
    name: t.string,
    services: t.record(t.string, t.boolean)
}));

export type SingleCountrySettingsType = {
    id: string,
    name: string,
    services: Record<string, boolean>
};

export type CountrySettingsType = Record<string, SingleCountrySettingsType>;

export const decodeResponse200 = (data: unknown): CountrySettingsType => {
    const decodeResult = Response200IO.decode(data);
    if (isRight(decodeResult)) {
        return decodeResult.right;
    }
    throw Error('Response decoding error getCountries -> get -> 200');
};

const decode = (status: number, data: ResponseType): CountrySettingsType=> {
    if (status === 200 && data.type === 'json') {
        return decodeResponse200(data.json);
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};


export const getCountries = {
    browser: {
        params: (): ParamsFetchType<void> => {
            return {
                type: MethodType.GET,
                url: '/api-web/admin/get-countries',
            };
        },
        decode: decode
    },
    express: {
        method: MethodType.GET,
        urlBrowser: '/api-web/admin/get-countries',
    },
    generateUrlApi: async (params: GenerateUrlApiParamsType<void>): Promise<GenerateUrlApiType> => {

        if (params.userSessionId === null) {
            return {
                passToBackend: false,
                status: 403,
                responseBody: {
                    errorMessage: 'User id invalid',
                }
            };
        }

        return {
            url: `${params.API_URL}/geolocation/country-config/${params.API_UNIVERSE}`,
            passToBackend: true,
            method: MethodType.GET,
        };
    }
};
